import jayapraksa1 from "./jayapraksa.webp";
import jayapraksa2 from "./13.webp";
import jayapraksa3 from "./14.webp";
import jayapraksa4 from "./15.webp";

const jayapraksa = [jayapraksa1, jayapraksa2, jayapraksa3, jayapraksa4];

export default jayapraksa;
